import DashboardLayout from "../../components/DashboardLayout";
import SalaryOfficerTable from "../../components/SalaryOfficerTable";

const OfficerDashboard = () => {
  return (
    <DashboardLayout role="officer">
      {/* <h2>Officer Dashboard</h2> */}
      <SalaryOfficerTable />
    </DashboardLayout>
  );
};

export default OfficerDashboard;
